import { trpc } from '@/lib/trpc';
import { toast } from 'sonner';

export function useStockSyncOverview() {
  return trpc.stockSync.getOverview.useQuery(undefined, {
    refetchInterval: 30_000,
  });
}

export function usePendingChanges(page: number, pageSize = 50) {
  return trpc.stockSync.getPendingChanges.useQuery(
    { limit: pageSize, offset: page * pageSize },
    { refetchInterval: 15_000 },
  );
}

/** Server-side filters for the push-history log (BLU-589). */
export interface PushHistoryFilters {
  /** Inclusive lower bound, ISO "YYYY-MM-DD". Omit for no lower bound. */
  fromDate?: string;
  /** Inclusive upper bound, ISO "YYYY-MM-DD". Omit for no upper bound. */
  toDate?: string;
  /** Derived push outcome. Omit for all statuses. */
  status?: 'success' | 'partial' | 'failed' | 'no_changes';
}

export function usePushHistory(
  page: number,
  filters: PushHistoryFilters = {},
  pageSize = 50,
) {
  return trpc.stockSync.getPushHistory.useQuery({
    limit: pageSize,
    offset: page * pageSize,
    // Undefined keys are dropped by tRPC/superjson, so "All" sends no filter.
    fromDate: filters.fromDate,
    toDate: filters.toDate,
    status: filters.status,
  });
}

export function useResolveChanges() {
  const utils = trpc.useUtils();
  return trpc.stockSync.resolveChanges.useMutation({
    onSuccess: (_result, variables) => {
      utils.stockSync.getPendingChanges.invalidate();
      utils.stockSync.getOverview.invalidate();
      const action = variables.action === 'approve' ? 'approved' : 'dismissed';
      toast.success(`${variables.ids.length} change${variables.ids.length > 1 ? 's' : ''} ${action}`);
    },
    onError: (error) => {
      toast.error(`Failed to resolve changes: ${error.message}`);
    },
  });
}
